import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const dpiAlertLocaleModule: LocaleModule = {
  name: "dpiAlert",
  messages: { en: en, it: it },
};
